export const CMS_API_BASE_URL = "https://cdn.contentful.com";
export const CMS_SPACE_ID = "ttyvpn56lncu";
export const CMS_ENVIRONMENT_ID = "master";
export const CMS_ACCESS_TOKEN = "XN1yP82AtLnkYoUfSdXf9NzzkS3y18u7pH8-VHN05NY";
